import React, { useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import { graphqlService } from '../../services/graphqlClient.js';
import './Settings.scss';
import ProductCounts from './counts/Products.jsx';
import ProductDrilldown from './counts/ProductDrilldown.jsx';
import FileCounts from './counts/FileCounts.jsx';
import CountryCounts from './counts/CountryCounts.jsx';
import ActivityCounts from './counts/ActivityCounts.jsx';

const Settings = () => {
  const [activeSection, setActiveSection] = useState('indexeddb');

  // Helper to get section from query string
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const section = params.get('section');
    if (['products', 'regions', 'activity'].includes(section)) {
      setActiveSection(section);
    } else {
      setActiveSection('products');
    }
  }, []);
  // Load product counts on mount


  const handleTabClick = (section) => {
    setActiveSection(section);
    const params = new URLSearchParams(window.location.search);
    params.set('section', section);
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
  };


  return (
    <div className="settings-root">
      <h3>Settings</h3>
      {/* Tab Navigation */}
      <div className="settings-tabs">
        <div
          className={`settings-tab${activeSection === 'products' ? ' active' : ''}`}
          onClick={() => handleTabClick('products')}
        >
          Products Dictionary
        </div>
        <div
          className={`settings-tab${activeSection === 'regions' ? ' active' : ''}`}
          onClick={() => handleTabClick('regions')}
        >
          Region-Country Dictionary
        </div>
        <div
          className={`settings-tab${activeSection === 'activity' ? ' active' : ''}`}
          onClick={() => handleTabClick('activity')}
        >
          Activity Dictionary
        </div>
        <div
          className={`settings-tab${activeSection === 'filenameCounts' ? ' active' : ''}`}
          onClick={() => handleTabClick('filenameCounts')}
        >
          Filename Counts
        </div>
        <div
          className={`settings-tab${activeSection === 'productDrilldown' ? ' active' : ''}`}
          onClick={() => handleTabClick('productDrilldown')}
        >
          Product Drill-Down
        </div>
      </div>

      {/* Activity Dictionary Section */}
      {activeSection === 'activity' && (
        <ActivityCounts />
      )}


      {/* Products Dictionary Section */}
      {activeSection === 'products' && (
        <ProductCounts  />
      )}
      
      {activeSection === 'regions' && (
        <CountryCounts />
      )}

      {activeSection === 'filenameCounts' && (
          <FileCounts />
      )}

      {activeSection === 'productDrilldown' && (
        <ProductDrilldown />
      )}
    </div>
  );
};

export default Settings;